import React, {PropTypes} from 'react';
import classNames from 'classnames';
import User from './User';

const UserComment = ({userId, username, when, showText = true, layout, children}) => {
  const userCommentClass = classNames({
    'user-comment': true,
    [`user-comment--${layout}`]: layout,
  });
  const userColumnClass = classNames({
    'user-comment__user': true,
    'user-comment__user--no-username': !showText,
  });

  return (<div className={userCommentClass}>
    <div className={userColumnClass}>
      {
        userId
          ? <User userId={userId} username={username} when={when} showText={showText} limitUserLength />
          : <div className="user-comment__no-avatar" />
      }
    </div>
    <div className="user-comment__text">
      {children}
    </div>
  </div>);
};

UserComment.propTypes = {
  userId: PropTypes.number,
  username: PropTypes.string,
  when: PropTypes.string,
  showText: PropTypes.bool,
  layout: PropTypes.string,
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
};

export default UserComment;

